import { ReferenceType } from '@modules/client';
import getApiReferenceTypeLabel from './getApiReferenceTypeLabel';

const getReferenceTypeFromPrefix = (
  typeAlias: string, // 'Material' or 'Enum.Material'
): {
  referenceType?: ReferenceType; // ReferenceType.ENUM
  nonprefixedAliasPart?: string; // 'Material'
} => {
  const lowercaseAlias = typeAlias.toLowerCase();

  let refType: ReferenceType | undefined;
  let nonprefixedAliasPart: string = typeAlias;

  // accomodate 'Datatype.xx' and 'Data Type.xx'
  const lowercaseDatatypePrefixes = ['datatype.', 'data type.'];
  lowercaseDatatypePrefixes.forEach((dtPrefix) => {
    if (lowercaseAlias.startsWith(dtPrefix)) {
      refType = ReferenceType.DATATYPE;
      nonprefixedAliasPart = typeAlias.slice(dtPrefix.length);
    }
  });
  [ReferenceType.CLASS, ReferenceType.ENUM].forEach((referenceType) => {
    const lowercaseRefTypeLabel = getApiReferenceTypeLabel(referenceType)?.toLowerCase();
    const prefix = `${lowercaseRefTypeLabel}.`;
    if (lowercaseRefTypeLabel && lowercaseAlias.startsWith(prefix)) {
      refType = referenceType;
      nonprefixedAliasPart = typeAlias.slice(prefix.length);
    }
  });
  return {
    referenceType: refType,
    nonprefixedAliasPart,
  };
};

export default getReferenceTypeFromPrefix;
